import { useReveal } from "../../hooks/useReveal";

const services = [
  {
    n: "01",
    title: "Pianificazione finanziaria",
    desc: "Disegnamo insieme un piano di vita su 5, 10, 30 anni: obiettivi, flussi di cassa, fiscalità, eventi straordinari. Niente template. Solo il tuo orizzonte.",
    bullets: ["Analisi patrimoniale 360°", "Goal-based planning", "Stress test e revisioni periodiche"],
    span: "lg:col-span-7 lg:row-span-2",
  },
  {
    n: "02",
    title: "Investimenti",
    desc: "Portafogli costruiti su evidenza accademica, costi minimi, asset allocation strategica. Indipendente da banche e SGR.",
    bullets: ["Selezione ETF e fondi", "Diversificazione globale", "Monitoraggio quantitativo"],
    span: "lg:col-span-5",
  },
  {
    n: "03",
    title: "Previdenza",
    desc: "Costruiamo la tua pensione integrativa con strumenti efficienti, fiscalmente vantaggiosi e coerenti con il piano.",
    bullets: ["PIP e Fondi pensione", "Ottimizzazione fiscale", "TFR e simulazioni INPS"],
    span: "lg:col-span-5",
  },
  {
    n: "04",
    title: "Protezione patrimonio",
    desc: "Strumenti assicurativi, successori e di tutela per mettere al riparo ciò che hai costruito da imprevisti, contenziosi e passaggi generazionali.",
    bullets: ["Polizze TCM e LTC", "Pianificazione successoria", "Trust e veicoli dedicati"],
    span: "lg:col-span-7",
  },
];

const ServiceCard = ({ s, idx }) => {
  const ref = useReveal();
  return (
    <article
      ref={ref}
      data-testid={`service-card-${idx}`}
      className={`reveal group relative bg-white border border-line p-10 md:p-12 flex flex-col justify-between min-h-[360px] transition-colors duration-500 hover:bg-navy hover:text-ivory ${s.span}`}
    >
      <div>
        <div className="flex items-baseline justify-between mb-10">
          <span className="font-serif text-5xl md:text-6xl text-gold group-hover:text-goldSoft transition-colors">
            {s.n}
          </span>
          <span className="text-[10px] tracking-[0.3em] uppercase text-muteText group-hover:text-ivory/60 transition-colors">
            Servizio
          </span>
        </div>
        <h3 className="display-3 mb-5 group-hover:text-ivory">{s.title}</h3>
        <p className="text-base md:text-lg leading-relaxed text-muteText group-hover:text-ivory/80 max-w-md">
          {s.desc}
        </p>
      </div>
      <ul className="mt-10 space-y-2 text-sm text-navy/85 group-hover:text-ivory/85">
        {s.bullets.map((b) => (
          <li key={b} className="flex items-center gap-3">
            <span className="text-gold group-hover:text-goldSoft text-base leading-none">•</span>
            <span>{b}</span>
          </li>
        ))}
      </ul>
    </article>
  );
};

export const Servizi = () => {
  const r = useReveal();
  return (
    <section
      id="servizi"
      data-testid="servizi-section"
      className="bg-[#F4F1EA] py-20 md:py-28 paper-grain"
    >
      <div className="container-editorial">
        <div ref={r} className="reveal max-w-3xl mb-20">
          <p className="overline mb-6">Servizi</p>
          <h2 data-testid="servizi-title" className="display-2">
            Quattro aree, un'unica<br />
            <em className="italic text-gold">strategia integrata</em>.
          </h2>
          <p className="lede mt-8 max-w-2xl">
            Ogni intervento nasce da una visione complessiva del tuo patrimonio. Non
            offro singoli prodotti, ma un disegno coerente che evolve con la tua vita.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
          {services.map((s, i) => (
            <ServiceCard key={s.n} s={s} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
